class SectionContentCards extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-content-cards-carousel]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });
  }

  initFunction() {
    if (!this.carousel) return;

    const { Swiper, Mousewheel } = this.swiperLib;

    this.swiper = new Swiper(this.carousel, {
      modules: [Mousewheel],
      spaceBetween: 20,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      grid: {
        rows: 1,
      },
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
}

if (!customElements.get("section-content-cards")) {
  customElements.define("section-content-cards", SectionContentCards);
}
